<template>
  <component :is="element" :class="['tabButton', classObj]" v-bind="$attrs">
    <slot />
  </component>
</template>

<script>
import BtnSpinner from '@/components/BtnSpinner';

export default {
  name: 'Button',

  components: { BtnSpinner },

  props: {
    active: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  computed: {
    element() {
      const { to, href } = this.$attrs;

      return to ? 'router-link' : href ? 'a' : 'button';
    },

    classObj() {
      const { active } = this;

      return { active };
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
